// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C-Z6","rootMobile":"styles_rootMobile__1zFD3"};